export const financing = {
  // Header
  title: 'Financing Solutions',
  subtitle: 'Flexible financing options to get your business moving. We work with multiple lenders to find the best rates and terms for your situation.',
  
  // Navigation Tabs
  overview: 'Overview',
  options: 'Financing Options',
  calculator: 'Payment Calculator',
  requirements: 'Requirements',
  
  // Overview Tab
  whyChooseFinancing: 'Why Choose Our Financing?',
  whyChooseFinancingDesc: 'We make it easy to get the commercial vehicle you need',
  quickApproval: 'Quick Approval',
  quickApprovalDesc: 'Get pre-approved in minutes with our streamlined application process',
  competitiveRates: 'Competitive Rates',
  competitiveRatesDesc: 'Access to multiple lenders ensures you get the best available rates',
  flexibleTerms: 'Flexible Terms',
  flexibleTermsDesc: 'Customize your payment schedule to match your business cash flow',
  readyToStart: 'Ready to Get Started?',
  readyToStartDesc: 'Our financing specialists are here to help you find the perfect solution for your business needs.',
  applyNow: 'Apply Now',
  speakWithSpecialist: 'Speak with Specialist',
  
  // Financing Options
  financingOptionsTitle: 'Financing Options',
  financingOptionsDesc: 'Choose the financing solution that works best for your business',
  traditionalFinancing: 'Traditional Financing',
  traditionalFinancingDesc: 'Standard auto loan with competitive rates for qualified buyers',
  commercialLease: 'Commercial Lease',
  commercialLeaseDesc: 'Lease options with lower monthly payments and tax benefits',
  interestRate: 'Interest Rate:',
  termLength: 'Term Length:',
  downPayment: 'Down Payment:',
  learnMore: 'Learn More',
  
  // Features
  fixedRates: 'Fixed interest rates',
  quickApprovalFeature: 'Quick approval',
  noPrepayment: 'No prepayment penalties',
  lowerPayments: 'Lower monthly payments',
  taxDeductible: 'Tax deductible',
  upgradeFlexibility: 'Upgrade flexibility',
  maintenancePackages: 'Maintenance packages available',
  
  // Payment Calculator
  calculatorTitle: 'Payment Calculator',
  calculatorDesc: 'Estimate your monthly payments (Quebec taxes included)',
  loanDetails: 'Loan Details',
  vehiclePrice: 'Vehicle Price (Before Taxes)',
  downPaymentLabel: 'Down Payment',
  interestRateLabel: 'Interest Rate (%)',
  loanTermLabel: 'Loan Term (months)',
  calculatePayment: 'Calculate Payment',
  paymentBreakdown: 'Payment Breakdown',
  monthlyPayment: 'Monthly Payment',
  taxBreakdown: 'Tax Breakdown (Quebec)',
  gst: 'GST (5%):',
  qst: 'QST (9.975%):',
  totalTaxes: 'Total Taxes:',
  vehiclePriceTaxes: 'Vehicle Price + Taxes',
  loanAmount: 'Loan Amount',
  totalInterest: 'Total Interest',
  totalAmount: 'Total Amount',
  estimateDisclaimer: 'This is an estimate including Quebec taxes (GST + QST). Actual rates and terms may vary based on credit approval.',
  
  // Requirements
  requirementsTitle: 'Financing Requirements',
  requirementsDesc: 'What you\'ll need to apply for financing',
  requiredDocuments: 'Required Documents',
  quickPreApproval: 'Quick Pre-Approval',
  quickPreApprovalDesc: 'Get pre-approved in as little as 15 minutes with our streamlined application process.',
  startApplication: 'Start Application',
  
  // Requirements List
  validLicense: 'Valid driver\'s license',
  proofIncome: 'Proof of income (last 2 pay stubs or tax returns)',
  bankStatements: 'Bank statements (last 3 months)',
  businessLicense: 'Business license (for commercial purchases)',
  proofWork: 'Proof of contractual work',
  insuranceInfo: 'Insurance information',
  references: 'References (personal and business)'
};